
import { Link, useLocation } from "react-router-dom";
import { 
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu as UIMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarMenuBadge
} from "@/components/ui/sidebar";
import { getSidebarIcon } from "./SidebarIcon";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { useAuth } from "@/context/AuthContext";
import { isSuperAdmin } from "@/utils/adminUtils";
import { useSubscription } from "@/hooks/subscription";

interface SidebarItemType {
  name: string;
  path: string;
}

interface SidebarMenuProps {
  items: SidebarItemType[];
}

export function SidebarMenu({ items }: SidebarMenuProps) {
  const location = useLocation();
  const [hasVisitedEarnRewards, setHasVisitedEarnRewards] = useLocalStorage(
    'has-visited-earn-rewards', 
    false
  );
  const { user } = useAuth();
  const { isSubscribed } = useSubscription();
  
  // Filter out admin menu items if user is not a super admin
  const filteredItems = items.filter(item => {
    // Hide Admin menu if user is not a super admin
    if (item.path === '/admin' && !isSuperAdmin(user?.id)) {
      return false;
    }
    return true;
  });
  
  return (
    <SidebarGroup>
      <SidebarGroupLabel>Menu</SidebarGroupLabel>
      <SidebarGroupContent>
        <UIMenu>
          {filteredItems.map((item) => {
            const Icon = getSidebarIcon(item.name as any);
            const isActive = location.pathname === item.path;
            const isEarnRewardsLink = item.name === 'Earn Rewards';
            const isFormsLink = item.path === '/forms';
            
            return (
              <SidebarMenuItem key={item.name}>
                <SidebarMenuButton 
                  asChild 
                  isActive={isActive}
                  tooltip={item.name}
                  onClick={isEarnRewardsLink 
                    ? () => setHasVisitedEarnRewards(true) 
                    : undefined
                  }
                  className={isEarnRewardsLink && !hasVisitedEarnRewards 
                    ? "animate-pulse-subtle" 
                    : ""
                  }
                >
                  <Link to={item.path}>
                    <Icon 
                      size={20} 
                      className={isEarnRewardsLink && !hasVisitedEarnRewards 
                        ? "text-green-500" 
                        : ""
                      } 
                    />
                    <span>{item.name}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
        </UIMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
